// import { Checkbox } from "../../../../../components/ui/checkbox"
// import { Card } from "../../../../../components/ui/card"
// import { Shield, Lock, Eye, Edit3, Trash2 } from "lucide-react"

// // Mock data
// const POLICIES = [
//   {
//     id: "policy-1",
//     name: "Content View",
//     description: "User can view and read all assigned content",
//     icon: Eye,
//     category: "Access",
//   },
//   {
//     id: "policy-2",
//     name: "Content Edit",
//     description: "User can modify and update assigned content",
//     icon: Edit3,
//     category: "Modification",
//   },
//   {
//     id: "policy-3",
//     name: "Content Delete",
//     description: "User can delete assigned content",
//     icon: Trash2,
//     category: "Modification",
//   },
//   {
//     id: "policy-4",
//     name: "Admin Access",
//     description: "User has administrative privileges",
//     icon: Lock,
//     category: "Administration",
//   },
// ]

// export function PolicyStep({ rights, updateRights }) {
//   const handlePolicyToggle = (policyId) => {
//     const isSelected = rights.policies_id.includes(policyId)
//     const newPolicies = isSelected
//       ? rights.policies_id.filter((id) => id !== policyId)
//       : [...rights.policies_id, policyId]

//     updateRights({ policies_id: newPolicies })
//   }

//   const categories = Array.from(new Set(POLICIES.map((p) => p.category)))

//   return (
//     <div className="space-y-6">
//       <div>
//         <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
//           <Shield className="w-5 h-5" />
//           Select Policies
//         </h3>
//         <p className="text-sm text-muted-foreground mb-6">
//           Choose which policies and permissions this user should have
//         </p>
//       </div>

//       {categories.map((category) => (
//         <div key={category}>
//           <h4 className="text-sm font-semibold text-muted-foreground uppercase tracking-wider mb-3">{category}</h4>
//           <div className="grid gap-3 mb-6">
//             {POLICIES.filter((p) => p.category === category).map((policy) => {
//               const Icon = policy.icon
//               const isSelected = rights.policies_id.includes(policy.id)

//               return (
//                 <Card
//                   key={policy.id}
//                   className={`p-4 border transition-all cursor-pointer ${
//                     isSelected ? "border-primary bg-primary/5" : "border-border bg-background hover:border-primary/50"
//                   }`}
//                 >
//                   <label className="flex items-start gap-3 cursor-pointer">
//                     <Checkbox
//                       checked={isSelected}
//                       onCheckedChange={() => handlePolicyToggle(policy.id)}
//                       className="mt-1"
//                     />
//                     <div className="flex-1">
//                       <div className="flex items-center gap-2 mb-1">
//                         <Icon className={`w-4 h-4 ${isSelected ? "text-primary" : "text-muted-foreground"}`} />
//                         <span className="font-medium text-foreground">{policy.name}</span>
//                       </div>
//                       <p className="text-xs text-muted-foreground">{policy.description}</p>
//                     </div>
//                   </label>
//                 </Card>
//               )
//             })}
//           </div>
//         </div>
//       ))}
//     </div>
//   )
// }



import { Checkbox } from "../../../../../components/ui/checkbox"
import { Card } from "../../../../../components/ui/card"
import { Shield, Eye, Edit3, Trash2 } from "lucide-react"

import { useSchoolsStore } from "../../../../../context/useSchoolsStore"
import { useModulesStore } from "../../../../../context/useModulesStore"
import { usePromptCategoriesStore } from "../../../../../context/usePromptCategoriesStore" 
import { usePromptsStore } from "../../../../../context/usePromptsStore"
import useLanguage from "../../../../../services/useLanguage";

const OPERATIONS = [
  { id: "create", label: "Create", description: "Create new items", icon: Edit3 },
  { id: "read", label: "Read", description: "View existing items", icon: Eye },
  { id: "update", label: "Update", description: "Update item details", icon: Edit3 },
  { id: "delete", label: "Delete", description: "Delete items", icon: Trash2 },
]

export function PolicyStep({ rights, updateRights }) {
  const { schools } = useSchoolsStore()
  const { modules } = useModulesStore()
  const { promptCategories } = usePromptCategoriesStore()
  const { prompts } = usePromptsStore()
  const currentLang = useLanguage();

  const selectedSchools = schools.filter((s) => Object.values(rights.schools).some((arr) => arr.includes(s.id)))
  const selectedModules = modules.filter((m) => Object.values(rights.modules).some((arr) => arr.includes(m.id)))
  const selectedCategories = promptCategories.filter((c) => Object.values(rights.prompt_categories).some((arr) => arr.includes(c.id)))
  const selectedPrompts = prompts.filter((p) => Object.values(rights.prompts).some((arr) => arr.includes(p.id)))

  const handleOperationToggle = (resourceType,resourceId,operation) => {
    const isSelected = rights[resourceType][operation].includes(resourceId)

    updateRights({
      [resourceType]: {
        ...rights[resourceType],
        [operation]: isSelected
          ? rights[resourceType][operation].filter((id) => id !== resourceId)
          : [...rights[resourceType][operation], resourceId],
      },
    })
  }

  return (
    <div className="space-y-8">
      <div>
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
          <Shield className="w-5 h-5" />
          Configure Operations & Permissions
        </h3>
        <p className="text-sm text-muted-foreground mb-6">
          Select which operations this user can perform on each selected resource
        </p>
      </div>

      {/* Schools */}
      {selectedSchools.length > 0 && (
        <div>
          <h4 className="text-sm font-semibold text-foreground mb-4">Schools</h4>
          <div className="space-y-3">
            {selectedSchools.map((school) => (
              <Card key={school.id} className="p-4 border border-border bg-background">
                <h5 className="font-medium text-foreground mb-3">{school.name}</h5>
                <div className="grid grid-cols-2 gap-3">
                  {OPERATIONS.map((op) => {
                    const Icon = op.icon
                    const isSelected = rights.schools[op.id].includes(school.id)
                    return (
                      <label
                        key={op.id}
                        className={`flex items-center gap-2 p-3 rounded-md cursor-pointer transition-colors ${
                          isSelected
                            ? "bg-primary/10 border border-primary/30"
                            : "bg-muted/30 border border-transparent hover:bg-muted/50"
                        }`}
                      >
                        <Checkbox
                          checked={isSelected}
                          onCheckedChange={() => handleOperationToggle("schools", school.id, op.id)}
                        />
                        <Icon className={`w-4 h-4 ${isSelected ? "text-primary" : "text-muted-foreground"}`} />
                        <div className="flex-1">
                          <span className="text-sm font-medium text-foreground">{op.label}</span>
                          <p className="text-xs text-muted-foreground">{op.description}</p>
                        </div>
                      </label>
                    )
                  })}
                </div>
              </Card>
            ))}
          </div>
        </div>
      )}

      {/* Modules */}
      {selectedModules.length > 0 && (
        <div>
          <h4 className="text-sm font-semibold text-foreground mb-4">Modules</h4>
          <div className="space-y-3">
            {selectedModules.map((module) => (
              <Card key={module.id} className="p-4 border border-border bg-background">
                <h5 className="font-medium text-foreground mb-3">{module.name}</h5>
                <div className="grid grid-cols-2 gap-3">
                  {OPERATIONS.map((op) => {
                    const Icon = op.icon
                    const isSelected = rights.modules[op.id].includes(module.id)
                    return (
                      <label
                        key={op.id}
                        className={`flex items-center gap-2 p-3 rounded-md cursor-pointer transition-colors ${
                          isSelected
                            ? "bg-primary/10 border border-primary/30"
                            : "bg-muted/30 border border-transparent hover:bg-muted/50"
                        }`}
                      >
                        <Checkbox
                          checked={isSelected}
                          onCheckedChange={() => handleOperationToggle("modules", module.id, op.id)}
                        />
                        <Icon className={`w-4 h-4 ${isSelected ? "text-primary" : "text-muted-foreground"}`} />
                        <div className="flex-1">
                          <span className="text-sm font-medium text-foreground">{op.label}</span>
                          <p className="text-xs text-muted-foreground">{op.description}</p>
                        </div>
                      </label>
                    )
                  })}
                </div>
              </Card>
            ))}
          </div>
        </div>
      )}

      {/* Prompt Categories */}
      {selectedCategories.length > 0 && (
        <div>
          <h4 className="text-sm font-semibold text-foreground mb-4">Prompt Categories</h4>
          <div className="space-y-3">
            {selectedCategories.map((category) => (
              <Card key={category.id} className="p-4 border border-border bg-background">
                <h5 className="font-medium text-foreground mb-3">{category.title[currentLang]}</h5>
                <div className="grid grid-cols-2 gap-3">
                  {OPERATIONS.map((op) => {
                    const Icon = op.icon
                    const isSelected = rights.prompt_categories[op.id].includes(category.id)
                    return (
                      <label
                        key={op.id}
                        className={`flex items-center gap-2 p-3 rounded-md cursor-pointer transition-colors ${
                          isSelected
                            ? "bg-primary/10 border border-primary/30"
                            : "bg-muted/30 border border-transparent hover:bg-muted/50"
                        }`}
                      >
                        <Checkbox
                          checked={isSelected}
                          onCheckedChange={() => handleOperationToggle("prompt_categories", category.id, op.id)}
                        />
                        <Icon className={`w-4 h-4 ${isSelected ? "text-primary" : "text-muted-foreground"}`} />
                        <div className="flex-1">
                          <span className="text-sm font-medium text-foreground">{op.label}</span>
                          <p className="text-xs text-muted-foreground">{op.description}</p>
                        </div>
                      </label>
                    )
                  })}
                </div>
              </Card>
            ))}
          </div>
        </div>
      )}

      {/* Prompts */}
      {selectedPrompts.length > 0 && (
        <div>
          <h4 className="text-sm font-semibold text-foreground mb-4">Prompts</h4>
          <div className="space-y-3">
            {selectedPrompts.map((prompt) => (
              <Card key={prompt.id} className="p-4 border border-border bg-background">
                <h5 className="font-medium text-foreground mb-3">{prompt.title[currentLang]}</h5>
                <div className="grid grid-cols-2 gap-3">
                  {OPERATIONS.map((op) => {
                    const Icon = op.icon
                    const isSelected = rights.prompts[op.id].includes(prompt.id)
                    return (
                      <label
                        key={op.id}
                        className={`flex items-center gap-2 p-3 rounded-md cursor-pointer transition-colors ${
                          isSelected
                            ? "bg-primary/10 border border-primary/30"
                            : "bg-muted/30 border border-transparent hover:bg-muted/50"
                        }`}
                      >
                        <Checkbox
                          checked={isSelected}
                          onCheckedChange={() => handleOperationToggle("prompts", prompt.id, op.id)}
                        />
                        <Icon className={`w-4 h-4 ${isSelected ? "text-primary" : "text-muted-foreground"}`} />
                        <div className="flex-1">
                          <span className="text-sm font-medium text-foreground">{op.label}</span>
                          <p className="text-xs text-muted-foreground">{op.description}</p>
                        </div>
                      </label>
                    )
                  })}
                </div>
              </Card>
            ))}
          </div>
        </div>
      )}

      {selectedSchools.length === 0 &&
        selectedModules.length === 0 &&
        selectedCategories.length === 0 &&
        selectedPrompts.length === 0 && (
          <div className="text-center py-8 text-muted-foreground">
            <p>No resources selected. Go back to previous steps and select schools, modules, categories, or prompts.</p>
          </div>
        )}
    </div>
  )
}
